import React, { useState, useEffect } from 'react';
import {
  IN_ROOM_DINING_MENU_EDIT_DRAWER,
  IN_ROOM_DINING_MENUS_TAB,
} from '../../../../../constants/InRoomDiningConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_SERVICES_IN_ROOM_DINING,
} from '../../../../../constants/RoleConsts';
import CustomDocumentViewer from '../../../../../shared/custom-document-viewer/Custom-Document-Viewer';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import CustomChip from '../../../../../shared/form-controls/custom-chip/Custom-Chip';
import MediaViewer from '../../../../../shared/media-viewer/MediaViewer';
import { isEmpty } from 'lodash';
import { inRoomDiningMenuSelector } from '../../../servicesSlice';
import { useSelector } from 'react-redux';

const MenuViewTabs = (props) => {
  const { hotel, onViewToggle, toggleDrawer, permissions, combo } = props;
  const inRoomDiningMenu = useSelector(inRoomDiningMenuSelector);
  const [tabValue, setTabValue] = useState(0);
  const [currentCombo, setCurrentCombo] = useState(null);

  useEffect(() => {
    if (inRoomDiningMenu.length) {
      let comboObj = {
        ...inRoomDiningMenu.find((tempComboInfo) => tempComboInfo.id === combo.id),
      };
      setCurrentCombo(comboObj);
    }
  }, [inRoomDiningMenu]);

  const onClickEdit = (e) => {
    toggleDrawer(IN_ROOM_DINING_MENU_EDIT_DRAWER, true, currentCombo);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderScreen = () => {
    return (
      <>
        {tabValue === 0 && (
          <div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-6'>
                <div className='details-label'>Name</div>
                <div className='details-value'>{currentCombo.name}</div>
              </div>
              <div className='col-md-6 '>
                <div className='details-label'>Status</div>
                <div className='details-value'>
                  <CustomChip
                    label={currentCombo.isActive ? 'Active' : 'Inactive'}
                    color={currentCombo.isActive ? 'primary' : 'default'}
                  />
                </div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-6'>
                <div className='details-label'>Menu Code</div>
                <div className='details-value'>{currentCombo.code || '----'}</div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-6'>
                <div className='details-label'>Description</div>
                <div className='details-value preview-breaks'>
                  {currentCombo.description || '----'}
                </div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-6'>
                <div className='details-label'>Document</div>
                <div className='details-value'>
                  {!isEmpty(currentCombo.menuURL) ? (
                    <CustomDocumentViewer
                      document={{ type: 'S3', url: currentCombo.menuURL }}
                      title={currentCombo.name}
                    ></CustomDocumentViewer>
                  ) : (
                    '----'
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {tabValue === 1 && (
          <div className='row pt-4 px-3'>
            <MediaViewer
              images={currentCombo.images}
              videos={currentCombo.videos}
              gifs={currentCombo.gifs}
              enabledMediaTabs={['image']}
            />
          </div>
        )}
      </>
    );
  };

  return (
    <>
      {currentCombo && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          renderScreen={renderScreen}
          onViewToggle={onViewToggle}
          handleTabChange={handleTabChange}
          tabList={IN_ROOM_DINING_MENUS_TAB}
          tabValue={tabValue}
          title={currentCombo.name}
          createdUserId={currentCombo.createdBy}
          isEditable={
            permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
          }
          tabClass='col-md-6'
        />
      )}
    </>
  );
};

export default MenuViewTabs;
